import React from 'react'
import {Section,SectionData} from "./Section";
import '../styles.css'
import {Cell, resolve} from '@q4us-sw/q4us-ui/lib/Cell'
import {Header,SectionTitle} from "./Header";
import {Button, Card, Modal, notification, Space, Tag, Typography} from "antd";
import {Establishments} from './Establishments'
import {Warehouse} from './Warehouse'
import {MOSS} from './MOSS'
import {Stores} from "./Stores";
import {submitEM, submitRefTableData, updateSelfRegApplication, submitDataWithConditions} from "../../api/api";
import {visualize,} from "../../api/api";
import {considered_as_eu_em, toEm} from '../util'
import {Notifications} from "./Notifications";
import {AdditionalInfo} from "./AdditionalInfo";


export const Application = ({
                                data,
                                fetchConfig = async ({schema})=>{return []},
                                onApprove,
                                onReject,
    onOSSRegRequest,
    onOSSRegComplete
})=>{

    const [opt,setOpt] = React.useState({countries:{},is_eu:false})

    const load = async ()=>{

        const {status = 500, data: {rows =  []} = {}} = await visualize('country');
        let obj = {};
        if(status === 200){
            obj = rows.reduce((acc, {id,...args})=>{
                acc[`${id}`] = {...args,id};
                return acc;
            },{})
        }
        const is_eu = considered_as_eu_em(data, obj);

        if(is_eu && data.ss_nr_oss_preferred_country === null && data.oss_special_schema_registered !== true ){
            const {is_reg_country_eu = false} = obj[`${data.registered_country}`]  || {}
            if(is_reg_country_eu)
                data['ss_nr_oss_preferred_country'] = data.registered_country;
        }
        setOpt({countries: obj,is_eu: is_eu});
    }

    React.useEffect(()=>{
        load();
    },[])

    const fc_rep_only = (!data.oss_special_schema_registered) && (!data.ss_nr_want_to_register) && data.ss_nr_continue_without_oss;

    const [values,setValues] = React.useState(data)

    return <React.Fragment>
        <div className="application" style={{height: 'calc(80vh - 90px)',width: 900,padding: 0, overflowY: 'auto'}}>
            <Header data={data} fetchConfig={async ()=>{
                return await fetchConfig({schema: "reg_approval_header"})
            }}/>
            <Notifications data={data} fetchConfig={fetchConfig}/>
            <Section
                title={"Created Date"}
                data={data}
                fetchConfig={async ()=>{
                    return await fetchConfig({schema: "created_date"})
                }}
                resolve={(props)=>{
                    return <Tag className={'section-value'}>{resolve(props)}</Tag>
                }}
            />

            <Section
                title={"Promotion Codes"}
                data={data}
                fetchConfig={async ()=>{
                    return await fetchConfig({schema: "reg_approval_promotion"})
                }}
                resolve={(props)=>{
                    return <Tag className={'section-value'}>{resolve(props)}</Tag>
                }}
            />
            <Section
                title={"Basic Information"}
                data={data}
                fetchConfig={async ()=>{
                    return await fetchConfig({schema: "reg_approval_basic"})
                }}
                resolve={(props)=>{
                    switch (props.name){
                        case "b2b_status":
                            return <Tag className={'section-value'}>{values.sales_type !== 'b2c_only' ? 'Enabled': 'Disabled'}</Tag>;
                        default:
                            return <Tag className={'section-value'}>{resolve(props)}</Tag>
                    }
                }}
            />
            <Establishments data={data} fetchConfig={fetchConfig}/>
            <Warehouse data={data} fetchConfig={fetchConfig}/>
            <MOSS
                data={values}
                fetchConfig={fetchConfig}
                isEu={opt.is_eu}
                onOSSRegComplete={onOSSRegComplete}
                onOSSRegistration={onOSSRegRequest} 
                setValues={setValues}/>
            <Stores data={data} fetchConfig={fetchConfig}/>
            <Section
                title={"Sales Information"}
                data={values}
                schema={"reg_approval_sales_info"}
                fetchConfig={async ()=>{
                    return await fetchConfig({schema: "reg_approval_sales_info"})
                }}
                onChange={(val)=>{
                    setValues(val)
                }}             
                isEditable={(cfg, v)=>{
                    if(v.status === 'SUBMITTED'){
                        return true;
                    }
                    return false;
                }}
                resolve={(props)=>{
                    switch (props.name){
                        default:
                            return <Tag className={'section-value'}>{resolve({...props, type: 'BOOLEAN'})}</Tag>
                    }
                }}
            />
            <AdditionalInfo data={data} fetchConfig={fetchConfig}/>
        </div>
        <div style={{height: 25}}>
            <Space style={{float:"right"}}>
                {data.status === 'SUBMITTED' && <Button disabled={data.status !== 'SUBMITTED' || data.oss_special_schema_registered} type={"primary"} className={"ant-danger"} onClick={async ()=>{
                                if(!(values.sales_type_i || values.sales_type_ii || values.sales_type_iii || values.sales_type_iv || values.sales_type_v || values.sales_type_vi || values.sales_type_vii || values.sales_type_viii || values.sales_type_ix || values.sales_type_x)){
                                    notification.error({message:"Sales Information need to be selected!"})
                                    return
                                }
                                if(values.ss_nr_oss_preferred_country != null) {
                                    const {self_reg_establishment,self_reg_document,self_reg_site,self_reg_warehouse_vat, id, ...args} = values;
                                    const res = await submitDataWithConditions('self_registration', {...args,status: 'REQUESTED_OSS_REG'}, [{ key: 'id', value: id }, { key: 'status', value: 'SUBMITTED' }])
                                    if(res.status === 200 && (res.data || {}).rowCount === 1){
                                        notification.success({message:"Application Moved to OSS Registration Stage"})
                                    }
                                    else{
                                        notification.error({message:"Moving to OSS Registration Stage failed"})
                                    }
                                    if(res.status === 200 && (res.data || {}).rowCount === 1)
                                        await onOSSRegRequest()
                                }else {
                                    notification.warn({message:"Please Fill the OSS Country of Identification"})
                                }
                            }}>Request Registration</Button>}
                <Button disabled={data.status !== 'REQUEST_APPROVAL'} onClick={async ()=>{
                    Modal.confirm({
                        title: `Do you want to reject application #${`${data?.id}`.padStart(6,'0')}`,
                        content: <React.Fragment>

                        </React.Fragment>,
                        okType: "danger",
                        okText: "Yes",
                        cancelText: "No",
                        onOk: async ()=>{
                            const {self_reg_establishment,self_reg_document,self_reg_site,self_reg_warehouse_vat,status, ...args} = data;
                            const res = await updateSelfRegApplication({...args,status: 'REJECTED'},status) || {}
                            if(res.status === 200)
                                notification.warn({message: "Application Rejected"})
                            if(res.status === 200){
                                if(onReject)
                                    await onReject();
                            }
                        }
                    })


                }}>
                 Reject
                </Button>
                <Button disabled={data.status !== 'REQUEST_APPROVAL' } type="primary" onClick={async ()=>{

                    Modal.confirm({
                        title: `Do you want to approve application #${`${data?.id}`.padStart(6,'0')}`,
                        content: <React.Fragment>

                        </React.Fragment>,
                        okType: "danger",
                        okText: "Yes",
                        cancelText: "No",
                        onOk: async ()=>{
                            const {self_reg_establishment,self_reg_document,self_reg_site,self_reg_warehouse_vat,status: application_status, ...args} = data;
                            const {id: application_id} = data
                            const obj = toEm(data, opt.countries)
                            const res = await submitEM({...obj, application_id});
                            const {status} = res || {}
                            if(status === 200) {
                                notification.success({message: "Application Approved"})
                                notification.success({message: "EM Registration Successful"})
                                if (onApprove)
                                    await onApprove();
                            }
                            else{
                                if(onReject)
                                    await onReject();
                            }
                        }
                    })


                }}>
                 Approve
                </Button>
                {(data.oss_special_schema_registered || fc_rep_only)  && ['SUBMITTED'].includes(data.status) && <Button type="primary" onClick={async () => {

                    const {self_reg_establishment,self_reg_document, self_reg_site, self_reg_warehouse_vat,status, ...args} = data;

                    const res = await submitRefTableData({...args, status: 'REQUEST_APPROVAL'}, 'self_registration')
                    if (res.status === 200)
                        notification.success({message: "Application Moved to Request Approval Stage"})
                    if(onOSSRegRequest)
                        await onOSSRegRequest()

                }}>
                    Request Approval
                </Button>}
            </Space>
        </div>
    </React.Fragment>
}
